import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import WorkOrderDataGrid from '../WorkOrderDataGrid';
import WorkOrderList from '../WorkOrderList';
import type { Filter } from '#/common/components/DataGrid';

interface WorkOrdersProps {
  omitColumns?: string[];
  hideNewAction?: boolean;
  permanentFilters?: Filter[];
}

const WorkOrders: React.FC<WorkOrdersProps> = ({
  omitColumns,
  hideNewAction,
  permanentFilters,
}) => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <WorkOrderDataGrid
          omitColumns={omitColumns}
          hideNewAction={hideNewAction}
          permanentFilters={permanentFilters}
        />
      </If>
      <If condition={!isDesktop}>
        <WorkOrderList hideNewAction={hideNewAction} permanentFilters={permanentFilters} />
      </If>
    </>
  );
};

export default React.memo(WorkOrders);
